import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createTenant,
  getTenants,
  getTenantById,
  updateTenant,
  deleteTenant,
} from "../../../api/tenant_api";

export const createTenantAction = createAsyncThunk(
  "tenant/createTenantAction",
  async (formData, { rejectWithValue }) => {
    try {
      const data = await createTenant(formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to create tenant");
    }
  }
);

export const getTenantsAction = createAsyncThunk(
  "tenant/getTenantsAction",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await getTenants(userId);
      // return data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch tenants");
    }
  }
);

export const getTenantByIdAction = createAsyncThunk(
  "tenant/getTenantByIdAction",
  async ({ tenantID, userId }, { rejectWithValue }) => {
    try {
      const data = await getTenantById(tenantID, userId);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch tenant");
    }
  }
);

export const updateTenantAction = createAsyncThunk(
  "tenant/updateTenantAction",
  async ({ tenantID, formData }, { rejectWithValue }) => {
    try {
      const data = await updateTenant(tenantID, formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to update tenant");
    }
  }
);

export const deleteTenantAction = createAsyncThunk(
  "tenant/deleteTenantAction",
  async ({ tenantID, userId }, { rejectWithValue }) => {
    try {
      await deleteTenant(tenantID, userId);
      return tenantID;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete tenant");
    }
  }
);
